var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "CSChatThai" },
    [
      _c(
        "div",
        {
          staticStyle: {
            background: "#2562af !important",
            "padding-bottom": "10px"
          }
        },
        [
          _c("div", { staticClass: "modalc", attrs: { id: "myModalImage" } }, [
            _c(
              "div",
              { attrs: { id: "headcaption" } },
              [
                _c(
                  "v-container",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticStyle: {
                              "text-align": "right",
                              padding: "30px 10px 5px 20px"
                            },
                            attrs: { xs12: "", md12: "", sm12: "" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "close",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.closemodal()
                                  }
                                }
                              },
                              [_vm._v("×")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("img", { staticClass: "modal-contentc", attrs: { id: "img01" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modalc", attrs: { id: "myModalNote" } }, [
            _c(
              "div",
              { attrs: { id: "headcaption" } },
              [
                _c(
                  "v-container",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticStyle: {
                              "text-align": "left",
                              padding: "30px 10px 5px 20px"
                            },
                            attrs: { xs6: "", md6: "", sm6: "" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "close",
                                staticStyle: {
                                  cursor: "pointer",
                                  "font-size": "15px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.closemodalnote()
                                  }
                                }
                              },
                              [_vm._v("×")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { xs6: "", md6: "", sm6: "" }
                          },
                          [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.create_note()
                                  }
                                }
                              },
                              [_vm._v("ยืนยัน")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  background: "white !important",
                  height: "100%",
                  overflow: "scroll",
                  padding: "10px"
                }
              },
              [
                _c("v-textarea", {
                  attrs: {
                    outlined: "",
                    name: "input-7-4",
                    rows: "23",
                    placeholder: "แชร์โน๊ตในห้องสนทนา"
                  },
                  model: {
                    value: _vm.note_data,
                    callback: function($$v) {
                      _vm.note_data = $$v
                    },
                    expression: "note_data"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticStyle: { margin: "0 !important" },
              attrs: { icon: "", disabled: _vm.stateChat != "chat" },
              on: {
                click: function($event) {
                  return _vm.gotopath("/list_room")
                }
              }
            },
            [
              _c("v-icon", { staticClass: "white--text" }, [
                _vm._v("chevron_left")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.roomDetail_SepType.room.room_type === "user"
            ? _c(
                "v-avatar",
                { staticClass: " profileBG", attrs: { size: "35" } },
                [
                  _vm.roomDetail_SepType.user.profile_picture
                    ? _c("img", {
                        staticClass: "alligator-turtle",
                        attrs: {
                          src:
                            _vm.backend +
                            _vm.roomDetail_SepType.user.profile_picture
                        }
                      })
                    : _c("span", { staticClass: "headline" }, [
                        _vm._v(
                          " \n      " +
                            _vm._s(
                              _vm.roomDetail_SepType.user.display_name.length >=
                                2
                                ? _vm.roomDetail_SepType.user.display_name.charAt(
                                    0
                                  ) +
                                    _vm.roomDetail_SepType.user.display_name.charAt(
                                      1
                                    )
                                : _vm.roomDetail_SepType.user.display_name.charAt(
                                    0
                                  )
                            )
                        )
                      ])
                ]
              )
            : _vm.roomDetail_SepType.room.room_type === "group"
            ? _c(
                "v-avatar",
                { staticClass: "profileBG", attrs: { size: "35" } },
                [
                  _vm.my_picture_Group
                    ? _c("img", {
                        staticClass: "alligator-turtle",
                        attrs: { src: _vm.my_picture_Group }
                      })
                    : _c("span", { staticClass: "headline" }, [
                        _vm._v(
                          _vm._s(
                            _vm.roomDetail_SepType.room.room_name.length >= 2
                              ? _vm.roomDetail_SepType.room.room_name.charAt(
                                  0
                                ) +
                                  _vm.roomDetail_SepType.room.room_name.charAt(
                                    1
                                  )
                              : _vm.roomDetail_SepType.room.room_name.charAt(0)
                          )
                        )
                      ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.roomDetail_SepType.room.room_type === "user"
            ? _c(
                "div",
                {
                  staticClass: "white--text",
                  staticStyle: {
                    "font-weight": "600",
                    "white-space": "nowrap",
                    width: "54vw",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                    display: "inline-block",
                    "vertical-align": "middle"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.roomDetail_SepType.user.display_name
                        ? _vm.roomDetail_SepType.user.display_name
                        : _vm.roomDetail_SepType.user.username
                    )
                  )
                ]
              )
            : _vm.roomDetail_SepType.room.room_type === "group"
            ? _c(
                "div",
                {
                  staticClass: "white--text",
                  staticStyle: {
                    "font-weight": "600",
                    "white-space": "nowrap",
                    width: "54vw",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                    display: "inline-block",
                    "vertical-align": "middle"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.roomDetail_SepType.room.room_name) +
                      " (" +
                      _vm._s(_vm.countgroupMember(_vm.roomDetail[0]).length) +
                      ")"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticStyle: {
                margin: "0 !important",
                right: "5px",
                float: "right"
              },
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.switchState()
                }
              }
            },
            [
              _vm.stateChat == "chat"
                ? _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("mdi-menu")
                  ])
                : _vm.stateChat == "menu"
                ? _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("clear")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("br")
        ],
        1
      ),
      _vm._v(" "),
      _vm.stateChat == "menu"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "MenuStyle" },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { xs2: "", xl2: "", lg2: "", md2: "", sm2: "" },
                        on: {
                          click: function($event) {
                            _vm.stateMenu = "image"
                          }
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            class:
                                              _vm.stateMenu == "image"
                                                ? "iconMenuHeaderSelected"
                                                : "iconMenuHeader"
                                          },
                                          on
                                        ),
                                        [_vm._v("fas fa-images")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1617802590
                            )
                          },
                          [_vm._v(" "), _c("span", [_vm._v("รูปภาพ")])]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { xs2: "", xl2: "", lg2: "", md2: "", sm2: "" },
                        on: {
                          click: function($event) {
                            _vm.stateMenu = "file"
                          }
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            class:
                                              _vm.stateMenu == "file"
                                                ? "iconMenuHeaderSelected"
                                                : "iconMenuHeader"
                                          },
                                          on
                                        ),
                                        [_vm._v("fas fa-file-alt")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2803011705
                            )
                          },
                          [_vm._v(" "), _c("span", [_vm._v("ไฟล์")])]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.roomDetail_SepType.room.room_type === "group"
                      ? _c(
                          "v-flex",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: {
                              xs2: "",
                              xl2: "",
                              lg2: "",
                              md2: "",
                              sm2: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.stateMenu = "detail"
                              }
                            }
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "iconMenuHeader",
                                                class:
                                                  _vm.stateMenu == "detail"
                                                    ? "iconMenuHeaderSelected"
                                                    : "iconMenuHeader"
                                              },
                                              on
                                            ),
                                            [_vm._v("fas fa-users-cog")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1382891071
                                )
                              },
                              [_vm._v(" "), _c("span", [_vm._v("ข้อมูลกลุ่ม")])]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.roomDetail_SepType.room.room_type === "group"
                      ? _c(
                          "v-flex",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: {
                              xs2: "",
                              xl2: "",
                              lg2: "",
                              md2: "",
                              sm2: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.leaveGroup()
                              }
                            }
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              { staticClass: "iconMenuHeader" },
                                              on
                                            ),
                                            [_vm._v("fas fa-sign-out-alt")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3727748863
                                )
                              },
                              [_vm._v(" "), _c("span", [_vm._v("ออกจากกลุ่ม")])]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.roomDetail_SepType.room.room_type === "user"
                      ? _c(
                          "v-flex",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: {
                              xs2: "",
                              xl2: "",
                              lg2: "",
                              md2: "",
                              sm2: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.stateMenu = "detailuser"
                              }
                            }
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "iconMenuHeader",
                                                class:
                                                  _vm.stateMenu == "detailuser"
                                                    ? "iconMenuHeaderSelected"
                                                    : "iconMenuHeader"
                                              },
                                              on
                                            ),
                                            [_vm._v("fas fa-users-cog")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2723002734
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("ข้อมูลเพื่อน")])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.stateMenu == "image"
              ? _c(
                  "div",
                  { staticStyle: { height: "70vh", overflow: "scroll" } },
                  [
                    _vm.listImage.length
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          _vm._l(_vm.listImage, function(file) {
                            return _c(
                              "v-flex",
                              { attrs: { xs4: "", "d-flex": "" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "d-flex",
                                    staticStyle: {
                                      cursor: "pointer",
                                      padding: "3px"
                                    },
                                    attrs: { flat: "", tile: "" }
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass:
                                        "grey lighten-2 alligator-turtle",
                                      attrs: {
                                        src:
                                          _vm.backend + file.message_data.url,
                                        "aspect-ratio": "1"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.zoom(file)
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "placeholder",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "fill-height": "",
                                                      "align-center": "",
                                                      "justify-center": "",
                                                      "ma-0": ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        indeterminate: "",
                                                        color: "grey lighten-5"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "text-align": "center"
                            }
                          },
                          [_vm._v("\n      ไม่พบการส่งภาพในห้องสนทนานี้\n    ")]
                        )
                  ],
                  1
                )
              : _vm.stateMenu == "file"
              ? _c(
                  "div",
                  { staticStyle: { height: "70vh", overflow: "scroll" } },
                  [
                    _vm.listFile.length
                      ? _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          _vm._l(_vm.listFile, function(file, index) {
                            return _c(
                              "v-list",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { "two-line": "", dense: "" }
                              },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-avatar",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: { color: "#1da1f2" },
                                            attrs: { large: "" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.extension(
                                                  file.message_data.url
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          {
                                            staticStyle: {
                                              color: "#2562af !important",
                                              "font-weight": "600",
                                              "white-space": "nowrap",
                                              width: "15em",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  file.message_data.file_name
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  file.message_data.file_name
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          { staticClass: "CSChatThai" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-size": "9px",
                                                  color: "#1010106b"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateMoment(
                                                      file.create_at
                                                    )
                                                  ) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm.timeMoment(
                                                        file.create_at
                                                      )
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "btnallow",
                                                attrs: {
                                                  depressed: "",
                                                  small: "",
                                                  href:
                                                    _vm.backend +
                                                    file.message_data.url,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    ดาวน์โหลด\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                index != _vm.listFile.length - 1
                                  ? _c("v-divider")
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "text-align": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n      ไม่พบการส่งไฟล์ในห้องสนทนานี้\n    "
                            )
                          ]
                        )
                  ],
                  1
                )
              : _vm.stateMenu == "note"
              ? _c(
                  "div",
                  { staticStyle: { height: "70vh", overflow: "scroll" } },
                  [
                    _vm.listNote.length
                      ? _c(
                          "div",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "v-layout",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { row: "", wrap: "" }
                              },
                              _vm._l(_vm.listNote, function(note, index) {
                                return _c(
                                  "v-layout",
                                  {
                                    attrs: { row: "", wrap: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openNote_byid(note.note_id)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: {
                                          padding: "15px 0px",
                                          display: "flex",
                                          "justify-content": "center"
                                        },
                                        attrs: {
                                          xs2: "",
                                          xl2: "",
                                          lg2: "",
                                          md2: "",
                                          sm2: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            staticClass: "profileBG",
                                            attrs: { size: "35" }
                                          },
                                          [
                                            note.user_created.profile_picture
                                              ? _c("img", {
                                                  staticClass:
                                                    "alligator-turtle",
                                                  attrs: {
                                                    src:
                                                      _vm.backend +
                                                      note.user_created
                                                        .profile_picture
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  { staticClass: "headline" },
                                                  [
                                                    _vm._v(
                                                      "\n        " +
                                                        _vm._s(
                                                          note.user_created
                                                            .display_name
                                                            .length >= 2
                                                            ? note.user_created.display_name.charAt(
                                                                0
                                                              ) +
                                                                note.user_created.display_name.charAt(
                                                                  1
                                                                )
                                                            : note.user_created.display_name.charAt(
                                                                0
                                                              )
                                                        )
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: {
                                          padding: "10px 10px 2px  0px",
                                          "text-align": "left"
                                        },
                                        attrs: {
                                          xs10: "",
                                          xl10: "",
                                          lg10: "",
                                          md10: "",
                                          sm10: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#2562af !important",
                                              "font-weight": "600",
                                              "white-space": "nowrap",
                                              width: "15em",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                note.user_created.display_name
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            width: "75vw",
                                            "white-space": "break-spaces",
                                            overflow: "hidden"
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm
                                                .convert(note.note_data.text)
                                                .replace(
                                                  /(?:\r\n|\r|\n)/g,
                                                  "<br>"
                                                )
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "font-size": "9px",
                                              color: "#1010106b",
                                              "margin-top": "10px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dateMoment(note.create_at)
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.timeMoment(note.create_at)
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs12: "",
                                          xl12: "",
                                          lg12: "",
                                          md12: "",
                                          sm12: ""
                                        }
                                      },
                                      [_c("v-divider")],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.createbuttonnote_show,
                                    expression: "createbuttonnote_show"
                                  }
                                ],
                                staticStyle: {
                                  background: "#2663af !important",
                                  bottom: "10px",
                                  right: "20px"
                                },
                                attrs: {
                                  fab: "",
                                  dark: "",
                                  small: "",
                                  absolute: "",
                                  bottom: "",
                                  rigth: ""
                                },
                                on: { click: _vm.openCreateNote }
                              },
                              [_c("v-icon", [_vm._v("mdi-plus")])],
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "text-align": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n      ไม่พบการส่งโน๊ตในห้องสนทนานี้\n      "
                            ),
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.createbuttonnote_show,
                                    expression: "createbuttonnote_show"
                                  }
                                ],
                                staticStyle: {
                                  background: "#2663af !important",
                                  bottom: "10px",
                                  right: "20px"
                                },
                                attrs: {
                                  fab: "",
                                  dark: "",
                                  small: "",
                                  absolute: "",
                                  bottom: "",
                                  rigth: ""
                                },
                                on: { click: _vm.openCreateNote }
                              },
                              [_c("v-icon", [_vm._v("mdi-plus")])],
                              1
                            )
                          ],
                          1
                        )
                  ]
                )
              : _vm.stateMenu == "detail"
              ? _c(
                  "div",
                  [
                    _c(
                      "v-layout",
                      {
                        staticStyle: { "margin-top": "20px", padding: "10px" },
                        attrs: { row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs12: "",
                              xl12: "",
                              lg12: "",
                              md12: "",
                              sm12: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "image-upload" },
                                  [
                                    _vm.my_picture_Group
                                      ? _c("v-img", {
                                          staticClass:
                                            "grey lighten-2 imageProfile alligator-turtle",
                                          attrs: {
                                            src: _vm.my_picture_Group,
                                            "aspect-ratio": "1"
                                          },
                                          on: { click: _vm.uppic },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "placeholder",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          "fill-height": "",
                                                          "align-center": "",
                                                          "justify-center": "",
                                                          "ma-0": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-progress-circular",
                                                          {
                                                            attrs: {
                                                              indeterminate: "",
                                                              color:
                                                                "grey lighten-5"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            1258913907
                                          )
                                        })
                                      : _c("v-img", {
                                          staticClass:
                                            "grey lighten-2 imageProfile alligator-turtle",
                                          attrs: {
                                            src:
                                              "/static/img/default_profile/group-white.png",
                                            "aspect-ratio": "1"
                                          },
                                          on: { click: _vm.uppic },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "placeholder",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          "fill-height": "",
                                                          "align-center": "",
                                                          "justify-center": "",
                                                          "ma-0": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-progress-circular",
                                                          {
                                                            attrs: {
                                                              indeterminate: "",
                                                              color:
                                                                "grey lighten-5"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            1258913907
                                          )
                                        }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "SettingImgBtn",
                                        attrs: { for: "file-input" }
                                      },
                                      [
                                        _vm._v(
                                          "\n              เปลี่ยนรูป\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        id: "file-input",
                                        type: "file",
                                        accept: "image/*"
                                      },
                                      on: { change: _vm.previewImageGroup }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "detailBG",
                                    on: {
                                      click: function($event) {
                                        _vm.dialogGroupName = true
                                      }
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "HeadersDetail" }, [
                                      _vm._v("ชื่อกลุ่ม")
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "Detail" }, [
                                      _vm._v(_vm._s(_vm.groupname) + " ")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "detailBG",
                                    on: {
                                      click: function($event) {
                                        return _vm.showdetail_memberGroup()
                                      }
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "HeadersDetail" }, [
                                      _vm._v(
                                        "สมาชิก (" +
                                          _vm._s(
                                            _vm.countgroupMember(
                                              _vm.roomDetail[0]
                                            ).length
                                          ) +
                                          ")"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.countgroupMember(_vm.roomDetail[0]),
                                      function(item) {
                                        return _c(
                                          "v-avatar",
                                          {
                                            staticClass: "profileBG_White ",
                                            staticStyle: {
                                              "margin-right": "-10px"
                                            },
                                            attrs: { size: "30" }
                                          },
                                          [
                                            item.user.profile_picture
                                              ? _c("v-img", {
                                                  staticClass:
                                                    "grey lighten-2 alligator-turtle",
                                                  attrs: {
                                                    src:
                                                      _vm.backend +
                                                      item.user.profile_picture,
                                                    "aspect-ratio": "1"
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  { staticClass: "headline " },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          item.user[
                                                            "display_name"
                                                          ].length >= 2
                                                            ? item.user[
                                                                "display_name"
                                                              ].charAt(0) +
                                                                item.user[
                                                                  "display_name"
                                                                ].charAt(1)
                                                            : item.user[
                                                                "display_name"
                                                              ].charAt(0)
                                                        ) +
                                                        "\n\n              "
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "btnSave",
                                        attrs: { small: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showdetail_memberGroup()
                                          }
                                        }
                                      },
                                      [_vm._v("จัดการสมาชิก")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm.stateMenu == "detailuser"
              ? _c(
                  "div",
                  [
                    _c(
                      "v-layout",
                      {
                        staticStyle: { "margin-top": "20px", padding: "10px" },
                        attrs: { row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs12: "",
                              xl12: "",
                              lg12: "",
                              md12: "",
                              sm12: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "image-upload" },
                                  [
                                    _vm.my_picture_Group
                                      ? _c("v-img", {
                                          staticClass:
                                            "grey lighten-2 imageProfile alligator-turtle",
                                          attrs: {
                                            src: _vm.my_picture_Group,
                                            "aspect-ratio": "1"
                                          }
                                        })
                                      : _c("v-img", {
                                          staticClass:
                                            "grey lighten-2 imageProfile alligator-turtle",
                                          attrs: {
                                            src:
                                              "/static/img/default_profile/man-white.png",
                                            "aspect-ratio": "1"
                                          }
                                        })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { margin: "20px" } }, [
                              _c("div", [
                                _c("p", { staticClass: "HeadersDetail" }, [
                                  _vm._v("ชื่อแสดง")
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "Detail" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.roomDetail_SepType.user.display_name
                                    ) + " "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "20px" } },
                                [
                                  _c("p", { staticClass: "HeadersDetail" }, [
                                    _vm._v("อีเมล")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "Detail" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.roomDetail_SepType.user.email
                                      ) + " "
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm.stateChat == "chat"
        ? _c(
            "div",
            [
              _vm.roomDetail_SepType.status == "pending"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        height: "auto",
                        background: "#61616126",
                        position: "fixed",
                        width: "100%"
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "padding-top": "2px !important",
                            "text-align": "center"
                          }
                        },
                        [_vm._v("คุณได้รับคำเชิญเข้ากลุ่ม")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "cancelGroup",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.cancelGroup()
                                }
                              }
                            },
                            [_vm._v("ปฏิเสธ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "acceptGroup",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.acceptGroup()
                                }
                              }
                            },
                            [_vm._v("ยืนยัน")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _vm.roomDetail_SepType.status !== "pending"
                  ? _c(
                      "div",
                      {
                        ref: "chatContainer",
                        staticClass: "chat-container",
                        style: _vm.scrollable,
                        on: { scroll: _vm.onScroll }
                      },
                      [
                        _c(
                          "vue-context",
                          {
                            ref: "vueSimpleContextMenu",
                            staticClass: "menuContext",
                            staticStyle: { "z-index": "1500" }
                          },
                          _vm._l(_vm.ListMenuRightClick, function(list, index) {
                            return _c(
                              "span",
                              {
                                class:
                                  index !== _vm.ListMenuRightClick.length - 1
                                    ? "MenuRightSelect"
                                    : "MenuRightSelect Last",
                                on: {
                                  click: function($event) {
                                    return _vm.SelectMenuRightClick(
                                      list.methods,
                                      list.detail
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(list.message))]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.message, function(msg, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "message",
                              class: {
                                own: msg.user_send.user_id == _vm.user_id
                              },
                              attrs: { id: msg.message_id }
                            },
                            [
                              index == 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "systemDateNonMGT CSChatThai",
                                      staticStyle: { "text-align": "center" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.dateMoment(msg.create_at))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm.dateMoment(
                                    _vm.message[index - 1].create_at
                                  ) != _vm.dateMoment(msg.create_at)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "systemDate CSChatThai",
                                      staticStyle: { "text-align": "center" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.dateMoment(msg.create_at))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.message_type == "system"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "systemMSG2 CSChatThai",
                                      staticStyle: { "text-align": "center" }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.timeMoment(msg.create_at)
                                          ) + "  "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      msg.message_data.verb === "joined_group"
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  msg.user_send.user_id ==
                                                    _vm.user_id
                                                    ? "คุณ"
                                                    : msg.user_send
                                                        .display_name + " "
                                                ) +
                                                " เข้าร่วมกลุ่ม"
                                            )
                                          ])
                                        : msg.message_data.verb ===
                                          "invited_to_group"
                                        ? _c(
                                            "p",
                                            [
                                              _c("Promised", {
                                                attrs: {
                                                  promise: _vm.GetDisplayUser(
                                                    msg.message_data.object
                                                  )
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "pending",
                                                      fn: function() {
                                                        return [
                                                          _c("p", [
                                                            _vm._v("Loading...")
                                                          ])
                                                        ]
                                                      },
                                                      proxy: true
                                                    },
                                                    {
                                                      key: "default",
                                                      fn: function(data) {
                                                        return [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                msg.user_send
                                                                  .user_id ==
                                                                  _vm.user_id
                                                                  ? "คุณ"
                                                                  : msg
                                                                      .user_send
                                                                      .display_name +
                                                                      " "
                                                              ) +
                                                              " เชิญ " +
                                                              _vm._s(data) +
                                                              " ให้เข้าร่วมกลุ่ม\n                  "
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        : msg.message_data.verb ===
                                          "remove_from_group"
                                        ? _c(
                                            "p",
                                            [
                                              _c("Promised", {
                                                attrs: {
                                                  promise: _vm.GetDisplayUser([
                                                    msg.message_data.object
                                                  ])
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "pending",
                                                      fn: function() {
                                                        return [
                                                          _c("p", [
                                                            _vm._v("Loading...")
                                                          ])
                                                        ]
                                                      },
                                                      proxy: true
                                                    },
                                                    {
                                                      key: "default",
                                                      fn: function(data) {
                                                        return [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                msg.user_send
                                                                  .user_id ==
                                                                  _vm.user_id
                                                                  ? "คุณ"
                                                                  : msg
                                                                      .user_send
                                                                      .display_name +
                                                                      " "
                                                              ) +
                                                              " ลบ " +
                                                              _vm._s(data) +
                                                              " ออกจากกลุ่ม\n                  "
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        : msg.message_data.verb ===
                                          "remove_pending_from_group"
                                        ? _c(
                                            "p",
                                            [
                                              _c("Promised", {
                                                attrs: {
                                                  promise: _vm.GetDisplayUser([
                                                    msg.message_data.object
                                                  ])
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "pending",
                                                      fn: function() {
                                                        return [
                                                          _c("p", [
                                                            _vm._v("Loading...")
                                                          ])
                                                        ]
                                                      },
                                                      proxy: true
                                                    },
                                                    {
                                                      key: "default",
                                                      fn: function(data) {
                                                        return [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                msg.user_send
                                                                  .user_id ==
                                                                  _vm.user_id
                                                                  ? "คุณ"
                                                                  : msg
                                                                      .user_send
                                                                      .display_name +
                                                                      " "
                                                              ) +
                                                              " ยกเลิกการเชิญ " +
                                                              _vm._s(data) +
                                                              " เข้ากลุ่ม\n                  "
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        : msg.message_data.verb === "left_group"
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  msg.user_send.user_id ==
                                                    _vm.user_id
                                                    ? "คุณ"
                                                    : msg.user_send
                                                        .display_name + " "
                                                ) +
                                                " ออกจากกลุ่ม"
                                            )
                                          ])
                                        : msg.message_data.verb ===
                                          "change_group_name"
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  msg.user_send.user_id ==
                                                    _vm.user_id
                                                    ? "คุณ"
                                                    : msg.user_send
                                                        .display_name + " "
                                                ) +
                                                ' เปลี่ยนชื่อกลุ่มเป็น "' +
                                                _vm._s(
                                                  msg.message_data.object
                                                ) +
                                                '"'
                                            )
                                          ])
                                        : msg.message_data.verb ===
                                          "change_group_picture"
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  msg.user_send.user_id ==
                                                    _vm.user_id
                                                    ? "คุณ"
                                                    : msg.user_send
                                                        .display_name + " "
                                                ) +
                                                " เปลี่ยนรูปโปรไฟล์กลุ่ม"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : msg.user_send.user_id != _vm.user_id &&
                                  msg.message_type !== "unsent_message"
                                ? _c("div", [
                                    index == 0
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "username CSChatThai"
                                            },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  staticClass:
                                                    "profileBG_White",
                                                  attrs: { size: "35" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getdetailUser_who(
                                                        msg.user_send
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  msg.user_send.profile_picture
                                                    ? _c("v-img", {
                                                        staticClass:
                                                          "grey lighten-2 alligator-turtle",
                                                        attrs: {
                                                          src:
                                                            _vm.backend +
                                                            msg.user_send
                                                              .profile_picture,
                                                          "aspect-ratio": "1"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key:
                                                                "placeholder",
                                                              fn: function() {
                                                                return [
                                                                  _c(
                                                                    "v-layout",
                                                                    {
                                                                      attrs: {
                                                                        "fill-height":
                                                                          "",
                                                                        "align-center":
                                                                          "",
                                                                        "justify-center":
                                                                          "",
                                                                        "ma-0":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            indeterminate:
                                                                              "",
                                                                            color:
                                                                              "grey lighten-5"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "headline "
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                msg.user_send
                                                                  .display_name
                                                                  .length >= 2
                                                                  ? msg.user_send.display_name.charAt(
                                                                      0
                                                                    ) +
                                                                      msg.user_send.display_name.charAt(
                                                                        1
                                                                      )
                                                                  : msg.user_send.display_name.charAt(
                                                                      0
                                                                    )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              ),
                                              _vm._v(
                                                "\n\n\n\n              " +
                                                  _vm._s(
                                                    msg.user_send.display_name
                                                  ) +
                                                  "\n            "
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm.message[index - 1].user_send
                                          .user_id != msg.user_send.user_id ||
                                        _vm.dateMoment(
                                          _vm.message[index - 1].create_at
                                        ) != _vm.dateMoment(msg.create_at) ||
                                        (_vm.message[index - 1].message_type ==
                                          "unsent_message" &&
                                          msg.message_type !==
                                            "unsent_message") ||
                                        (_vm.message[index - 1].message_type ==
                                          "system" &&
                                          msg.message_type !== "system")
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "username CSChatThai"
                                            },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  staticClass:
                                                    "profileBG_White",
                                                  attrs: { size: "35" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getdetailUser_who(
                                                        msg.user_send
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  msg.user_send.profile_picture
                                                    ? _c("v-img", {
                                                        staticClass:
                                                          "grey lighten-2 alligator-turtle",
                                                        attrs: {
                                                          src:
                                                            _vm.backend +
                                                            msg.user_send
                                                              .profile_picture,
                                                          "aspect-ratio": "1"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key:
                                                                "placeholder",
                                                              fn: function() {
                                                                return [
                                                                  _c(
                                                                    "v-layout",
                                                                    {
                                                                      attrs: {
                                                                        "fill-height":
                                                                          "",
                                                                        "align-center":
                                                                          "",
                                                                        "justify-center":
                                                                          "",
                                                                        "ma-0":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            indeterminate:
                                                                              "",
                                                                            color:
                                                                              "grey lighten-5"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "headline "
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                msg.user_send
                                                                  .display_name
                                                                  .length >= 2
                                                                  ? msg.user_send.display_name.charAt(
                                                                      0
                                                                    ) +
                                                                      msg.user_send.display_name.charAt(
                                                                        1
                                                                      )
                                                                  : msg.user_send.display_name.charAt(
                                                                      0
                                                                    )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              ),
                                              _vm._v(
                                                "\n\n\n            " +
                                                  _vm._s(
                                                    msg.user_send.display_name
                                                  ) +
                                                  "\n          "
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : msg.user_send.user_id == _vm.user_id &&
                                  msg.message_type !== "unsent_message"
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "pr-2",
                                      staticStyle: {
                                        "font-size": "9px",
                                        color: "#424242b3",
                                        display: "inline-block"
                                      }
                                    },
                                    [
                                      msg.get_read_in_room &&
                                      msg.get_read_in_room.length != 0
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                อ่านแล้ว \n                "
                                            ),
                                            _vm.roomDetail_SepType.room
                                              .room_type === "group"
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      msg.get_read_in_room
                                                        .length
                                                    ) + " คน "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("br")
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        " \n              " +
                                          _vm._s(
                                            _vm.timeMoment(msg.create_at)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.message_type == "unsent_message"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "systemMSG CSChatThai",
                                      staticStyle: { "text-align": "center" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            msg.user_send.user_id == _vm.user_id
                                              ? "คุณ"
                                              : msg.user_send.display_name + " "
                                          ) + " ยกเลิกข้อความแล้ว"
                                        )
                                      ])
                                    ]
                                  )
                                : msg.message_type == "text"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "content CSChatThai",
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["reply", "cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm
                                              .convert(msg.message_data.text)
                                              .replace(
                                                /(?:\r\n|\r|\n)/g,
                                                "<br>"
                                              )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.convertURL(msg.message_data.text),
                                        function(x) {
                                          return _vm.convertURL(
                                            msg.message_data.text
                                          )
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "link-prevue",
                                                    {
                                                      attrs: { url: x },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              props
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "v-layout",
                                                                  {
                                                                    staticStyle: {
                                                                      "margin-top":
                                                                        "10px"
                                                                    },
                                                                    attrs: {
                                                                      row: "",
                                                                      wrap: ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.clicklink_website(
                                                                          props.url
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticClass:
                                                                          "border_website",
                                                                        attrs: {
                                                                          xs9:
                                                                            "",
                                                                          xl9:
                                                                            "",
                                                                          lg9:
                                                                            "",
                                                                          md9:
                                                                            "",
                                                                          sm9:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "title_website"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                props.title
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "description_website"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                props.description
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticClass:
                                                                          "centerimg_website",
                                                                        attrs: {
                                                                          xs3:
                                                                            "",
                                                                          xl3:
                                                                            "",
                                                                          lg3:
                                                                            "",
                                                                          md3:
                                                                            "",
                                                                          sm3:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        props.img
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "img_website",
                                                                                attrs: {
                                                                                  src:
                                                                                    props.img
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "loading" },
                                                        [_c("span")]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : msg.message_type === "note"
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "contentNote CSChatThai",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { slot: "activator" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openNote_byid(
                                            msg.message_data.note_id
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "white--text",
                                          staticStyle: {
                                            background: "#b4d1f5",
                                            "border-radius": "10px",
                                            padding: "10px",
                                            "padding-bottom": "0px",
                                            width: "100%",
                                            "box-shadow": "none"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                "text-align": "left"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs12: "",
                                                    sm12: "",
                                                    md12: "",
                                                    lg12: "",
                                                    xl12: ""
                                                  }
                                                },
                                                [
                                                  _c("p", {
                                                    staticStyle: {
                                                      color: "black"
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm
                                                          .convert(
                                                            msg.message_data
                                                              .text
                                                          )
                                                          .replace(
                                                            /(?:\r\n|\r|\n)/g,
                                                            "<br>"
                                                          )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  msg.message_data.text
                                                    .length == 20
                                                    ? _c("p", [_vm._v(" ...")])
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-divider", {
                                            staticStyle: {
                                              "border-color":
                                                "#31394121 !important"
                                            },
                                            attrs: { light: "" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            {
                                              staticStyle: {
                                                "padding-left": "0px !important"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#4c6281 !important"
                                                  }
                                                },
                                                [_vm._v(" โน๊ต ")]
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    color: "#4c6281 !important",
                                                    right: "0",
                                                    position: "absolute"
                                                  }
                                                },
                                                [_vm._v("navigate_next ")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : msg.message_type == "image"
                                ? _c("img", {
                                    staticClass: "contentimage",
                                    staticStyle: {
                                      "max-height": "150px",
                                      "max-width": "60vw",
                                      "border-radius": "10px",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      src: _vm.backend + msg.message_data.url
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.zoom(msg)
                                      },
                                      contextmenu: function($event) {
                                        $event.preventDefault()
                                        return _vm.RightClickDialog(
                                          $event,
                                          ["reply", "cancel"],
                                          msg
                                        )
                                      }
                                    }
                                  })
                                : msg.message_type == "file" &&
                                  _vm.extension(msg.message_data.url) ===
                                    "fas fa-file-alt"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "contentfile CSChatThai",
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("pdf", {
                                        attrs: {
                                          src:
                                            _vm.backend + msg.message_data.url,
                                          page: 1
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "wrap",
                                          staticStyle: {
                                            "font-size": "12px",
                                            "text-align": "left",
                                            "font-weight": "600",
                                            "margin-top": "5px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(msg.message_data.file_name)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "textDownload",
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadFile(
                                                    msg.message_data
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("ดาวน์โหลด")]
                                          ),
                                          _vm._v(
                                            "\n                    |\n                    "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "textDownload",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openFilePDF(
                                                    msg.message_data
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("แสดง")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : msg.message_type == "file"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "contentfile CSChatThai",
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs3: "",
                                                xl3: "",
                                                md3: "",
                                                sm3: "",
                                                lg3: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { staticClass: "iconFile" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.extension(
                                                        msg.message_data.url
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs9: "",
                                                xl9: "",
                                                md9: "",
                                                sm9: "",
                                                lg9: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "wrap",
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "text-align": "left",
                                                    "border-left":
                                                      "1px solid white",
                                                    "padding-left": "5px",
                                                    "margin-bottom":
                                                      "10px !important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      msg.message_data.file_name
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "textDownload",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.downloadFile(
                                                        msg.message_data
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("ดาวน์โหลด")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : msg.message_type == "video"
                                ? _c(
                                    "video",
                                    {
                                      staticClass: "contentvideo",
                                      staticStyle: {
                                        "border-radius": "10px",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        "max-height": "150px",
                                        "max-width": "60vw"
                                      },
                                      attrs: { controls: "" },
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src:
                                            _vm.backend + msg.message_data.url,
                                          type:
                                            "video/" +
                                            msg.message_data.url.split(".")[
                                              msg.message_data.url.split(".")
                                                .length - 1
                                            ]
                                        }
                                      })
                                    ]
                                  )
                                : msg.message_type == "audio"
                                ? _c(
                                    "audio",
                                    {
                                      staticStyle: {
                                        "border-radius": "10px",
                                        width: "60vw",
                                        height: "30px"
                                      },
                                      attrs: { controls: "" },
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src:
                                            _vm.backend + msg.message_data.url,
                                          type:
                                            "audio/" +
                                            msg.message_data.url.split(".")[
                                              msg.message_data.url.split(".")
                                                .length - 1
                                            ]
                                        }
                                      })
                                    ]
                                  )
                                : msg.message_type == "reply_text"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "content CSChatThai",
                                      staticStyle: { width: "75% !important" },
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["reply", "cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticStyle: {
                                            "padding-bottom": "10px"
                                          },
                                          attrs: { row: "", wrap: "" }
                                        },
                                        [
                                          msg.message_data.message_data_reply
                                            .message_type !== "unsent_message"
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs3: "",
                                                    xl3: "",
                                                    md3: "",
                                                    sm3: "",
                                                    lg3: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass:
                                                        "profileBG_White",
                                                      attrs: { size: "25" }
                                                    },
                                                    [
                                                      msg.message_data
                                                        .message_data_reply
                                                        .user_send
                                                        .profile_picture
                                                        ? _c("v-img", {
                                                            staticClass:
                                                              "grey lighten-2 alligator-turtle",
                                                            attrs: {
                                                              src:
                                                                _vm.backend +
                                                                msg.message_data
                                                                  .message_data_reply
                                                                  .user_send
                                                                  .profile_picture,
                                                              "aspect-ratio":
                                                                "1"
                                                            }
                                                          })
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "headline "
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                  " +
                                                                  _vm._s(
                                                                    msg
                                                                      .message_data
                                                                      .message_data_reply
                                                                      .user_send
                                                                      .display_name
                                                                      .length >=
                                                                      2
                                                                      ? msg.message_data.message_data_reply.user_send.display_name.charAt(
                                                                          0
                                                                        ) +
                                                                          msg.message_data.message_data_reply.user_send.display_name.charAt(
                                                                            1
                                                                          )
                                                                      : msg.message_data.message_data_reply.user_send.display_name.charAt(
                                                                          0
                                                                        )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs9: "",
                                                xl9: "",
                                                md9: "",
                                                sm9: "",
                                                lg9: ""
                                              }
                                            },
                                            [
                                              msg.message_data
                                                .message_data_reply
                                                .message_type !==
                                              "unsent_message"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "inline-block"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "font-weight": "600"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              msg.message_data
                                                                .message_data_reply
                                                                .user_send
                                                                .display_name
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      msg.message_data
                                                        .message_data_reply
                                                        .message_type ==
                                                        "text" ||
                                                      msg.message_data
                                                        .message_data_reply
                                                        .message_type ==
                                                        "reply_text"
                                                        ? _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                msg.message_data
                                                                  .message_data_reply
                                                                  .message_data
                                                                  .text
                                                              )
                                                            )
                                                          ])
                                                        : msg.message_data
                                                            .message_data_reply
                                                            .message_type ==
                                                          "image"
                                                        ? _c("p", [
                                                            _vm._v("รูป")
                                                          ])
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#35353594 !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ไม่สามารถรองรับในเวอร์ชันนี้"
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              msg.message_data
                                                .message_data_reply
                                                .message_type ==
                                              "unsent_message"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        color:
                                                          "#35353594 !important"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ไม่สามารถแสดงข้อความนี้ได้"
                                                      )
                                                    ]
                                                  )
                                                : msg.message_data
                                                    .message_data_reply
                                                    .message_type == "image"
                                                ? _c("img", {
                                                    staticClass: "contentimage",
                                                    staticStyle: {
                                                      float: "right",
                                                      display: "inline-block",
                                                      "max-height": "40px",
                                                      "max-width": "20vw",
                                                      "border-radius": "10px",
                                                      cursor: "pointer"
                                                    },
                                                    attrs: {
                                                      src:
                                                        _vm.backend +
                                                        msg.message_data
                                                          .message_data_reply
                                                          .message_data.url
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(msg.message_data.text)
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : msg.message_type == "video_m3u8"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "CSChatThai",
                                      staticStyle: { display: "inline-block" },
                                      on: {
                                        contextmenu: function($event) {
                                          $event.preventDefault()
                                          return _vm.RightClickDialog(
                                            $event,
                                            ["cancel"],
                                            msg
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vplayer", {
                                        staticClass: "contentvideo",
                                        attrs: {
                                          playerOptions: {
                                            type: "application/x-mpegURL", //媒体类型，m3u8请给application/x-mpegURL或者application/vnd.apple.mpegURL，其他的会默认为普通音视频，注：微信不支持m3u8
                                            src:
                                              _vm.backend +
                                              msg.message_data.url, //视频地址
                                            preload: true, //是否预下载，默认为true
                                            autoplay: false, //是否自动播放（兼容性不太好），默认为false
                                            isLoop: false, //是否循环，默认不循环
                                            playsinline: false, //h5是否行内播放，默认false，有兼容性问题
                                            poster:
                                              _vm.backend +
                                              msg.message_data.thumbnail,
                                            controls:
                                              "progress,current,durration,volume", //显示的控件,volume只有视频有，没有配置controls项则全部显示。
                                            crossOrigin: false //设置视频的 CORS 设置。
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : msg.message_type !== "system" &&
                                  msg.message_type !== "unsent_message"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "contentnot_support CSChatThai",
                                      staticStyle: { "margin-top": "5px" }
                                    },
                                    [
                                      _c("span", {}, [
                                        _vm._v(
                                          " ข้อความประเภทนี้ยังไม่รองรับในเวอร์ชันนี้ "
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.user_send.user_id != _vm.user_id &&
                              msg.message_type !== "unsent_message" &&
                              msg.message_type !== "system"
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "pr-2",
                                      staticStyle: {
                                        "font-size": "10px",
                                        color: "#424242b3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.timeMoment(msg.create_at))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.showmention
                ? _c(
                    "v-flex",
                    {
                      staticClass: "showmentionCSS",
                      attrs: { lg12: "", md12: "", sm12: "", xl12: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs2: "",
                                xl2: "",
                                md2: "",
                                sm2: "",
                                lg2: ""
                              }
                            },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "profileBG_White",
                                  attrs: { size: "35" }
                                },
                                [
                                  _vm.detailMSGSelected.user_send
                                    .profile_picture
                                    ? _c("img", {
                                        staticClass: "alligator-turtle",
                                        attrs: {
                                          src:
                                            _vm.backend +
                                            _vm.detailMSGSelected.user_send
                                              .profile_picture
                                        }
                                      })
                                    : _c("span", { staticClass: "headline " }, [
                                        _vm._v(
                                          "\n" +
                                            _vm._s(
                                              _vm.detailMSGSelected.user_send
                                                .display_name.length >= 2
                                                ? _vm.detailMSGSelected.user_send.display_name.charAt(
                                                    0
                                                  ) +
                                                    _vm.detailMSGSelected.user_send.display_name.charAt(
                                                      1
                                                    )
                                                : _vm.detailMSGSelected.user_send.display_name.charAt(
                                                    0
                                                  )
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs9: "",
                                xl9: "",
                                md9: "",
                                sm9: "",
                                lg9: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "inline-block" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        color: "white"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.detailMSGSelected.user_send
                                            .display_name
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.detailMSGSelected.message_type ==
                                    "text" ||
                                  _vm.detailMSGSelected.message_type ==
                                    "reply_text"
                                    ? _c(
                                        "p",
                                        { staticStyle: { color: "white" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.detailMSGSelected.message_data
                                                .text
                                            )
                                          )
                                        ]
                                      )
                                    : _vm.detailMSGSelected.message_type ==
                                      "image"
                                    ? _c(
                                        "p",
                                        { staticStyle: { color: "white" } },
                                        [_vm._v("รูป")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.detailMSGSelected.message_type == "image"
                                ? _c("img", {
                                    staticClass: "contentimage",
                                    staticStyle: {
                                      float: "right",
                                      display: "inline-block",
                                      "max-height": "40px",
                                      "max-width": "20vw",
                                      "border-radius": "10px",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      src:
                                        _vm.backend +
                                        _vm.detailMSGSelected.message_data.url
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: {
                                xs1: "",
                                xl1: "",
                                md1: "",
                                sm1: "",
                                lg1: ""
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { color: "white" },
                                  on: {
                                    click: function($event) {
                                      _vm.showmention = false
                                    }
                                  }
                                },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.roomDetail_SepType.status !== "pending"
                ? _c(
                    "div",
                    { staticClass: "typer" },
                    [
                      _c("v-textarea", {
                        attrs: {
                          solo: "",
                          placeholder: "พิมพ์ข้อความ....",
                          "hide-details": "",
                          height: "45",
                          rows: "1"
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            if (
                              $event.ctrlKey ||
                              $event.shiftKey ||
                              $event.altKey ||
                              $event.metaKey
                            ) {
                              return null
                            }
                            return _vm.sendMessage($event)
                          }
                        },
                        model: {
                          value: _vm.content,
                          callback: function($$v) {
                            _vm.content = $$v
                          },
                          expression: "content"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-menu",
                        {
                          attrs: { top: "", "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "emoji-panel",
                                          attrs: { dark: "", icon: "" }
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "#2562af" } },
                                          [_vm._v("add_circle_outline")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3959229114
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-card",
                            {
                              staticStyle: {
                                height: "60px",
                                width: "80vw",
                                "border-radius": "10px",
                                background: "#0b2a52 !important"
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs4: "",
                                        xl4: "",
                                        md4: "",
                                        sm4: "",
                                        lg4: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btnmsgMore",
                                                        staticStyle: {
                                                          margin: "5px"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.uppicfile()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "30px",
                                                                color: "#2562af"
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "far fa-file-image"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3611559671
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [_vm._v("ส่งรูป")])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs4: "",
                                        xl4: "",
                                        md4: "",
                                        sm4: "",
                                        lg4: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btnmsgMore",
                                                        staticStyle: {
                                                          margin: "5px"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.upfile()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "30px",
                                                                color: "#2562af"
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "fas fa-file-alt"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3286609330
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [_vm._v("ส่งไฟล์")])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "none" } }, [
                _c("input", {
                  attrs: {
                    multiple: "",
                    type: "file",
                    id: "uploadpic",
                    accept: "image/*"
                  },
                  on: {
                    change: function($event) {
                      return _vm.onimgSelected($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { multiple: "", type: "file", id: "uploadfileChat" },
                  on: {
                    change: function($event) {
                      return _vm.onimgSelected($event)
                    }
                  }
                })
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ShowDetailmemberDialog", {
        attrs: {
          dialogGroupMember: _vm.dialogGroupMember,
          room_id: _vm.room_id
        },
        on: { closeDetailMember: _vm.closeDetailMember }
      }),
      _vm._v(" "),
      _c("EditGroupNameDialog", {
        attrs: {
          dialogGroupName: _vm.dialogGroupName,
          roomDetail_SepType: _vm.roomDetail_SepType
        },
        on: { closeEditGroupname: _vm.closeEditGroupname }
      }),
      _vm._v(" "),
      _c("ShowDetailUserDialog", {
        attrs: {
          dialogDetailUser: _vm.dialogDetailUser,
          UserDetail_who: _vm.UserDetail_who
        },
        on: { closeDetailUser: _vm.closeDetailUser }
      }),
      _vm._v(" "),
      _c("NoteDialog", {
        attrs: { dialogNote: _vm.dialogNote, note_id: _vm.note_id },
        on: { closeNote: _vm.closeNote, changeNote: _vm.changeNote }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14ce43ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ce43ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/ListChat.vue
// module id = null
// module chunks = 